<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout wrap>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">PO detail</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-layout wrap>
                <v-flex xs4>
                  <v-card color="white">
                    <v-card-title class="pb-0">
                      <div class="subheading">Date :</div>
                      <h3>{{po_created_date}}</h3>
                    </v-card-title>
                    <v-card-title class="pb-0">
                      <div class="subheading">Farmer :</div>
                      <h3>{{farmer_name}}</h3>
                    </v-card-title>
                    <v-card-title>
                      <div class="subheading">Driver :</div>
                      <h3>{{driver_name}}</h3>
                    </v-card-title>
                    <v-card-title>
                      <div class="subheading">Sewa price :</div>
                      <h3>{{sprice}}</h3>
                    </v-card-title>
                     <v-card-title>
                      <div class="subheading">Ref number :</div>
                      <h3>{{ref_no}}</h3>
                    </v-card-title>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-btn color="primary" @click="dialog_change_detail=true">Change</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap row>
        <!--  Select basket -->
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">Adjust Basket quantity in this PO</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-flex xs6>
                <v-btn-toggle v-model="basket_control_type" mandatory>
                  <v-btn value="farmer_return">farmer Return Empty Basket</v-btn>
                  <v-btn value="driver_send">driver Give Empty Basket to Farm</v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex xs2></v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="basket_quantity"
                  v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 0)"
                  ref="basket_q"
                  type="number"
                  label="qty(no need type-)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="saving"
                  @click="update_basket()"
                >Update Basket</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <!-- <v-layout wrap row>

                <v-flex xs6>
                  <v-btn-toggle v-model="basket_control_type" mandatory>
                    <v-btn value="farmer_return">farmer Return Empty Basket</v-btn>
                    <v-btn value="driver_send">driver Give Empty Basket to Farm</v-btn>
                  </v-btn-toggle>
                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="basket_quantity"
                    v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 0)"
                    ref="basket_q"
                    type="number"
                    label="qty(no need type-)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-btn color="primary" @click="update_basket()">Update Basket</v-btn>
                </v-flex>
              </v-layout>-->
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span
                    style="color:#0cabc2"
                  >Add stock (Total: RM{{parseFloat(total_amount).toFixed(2)}})</span>
                </v-toolbar-title>
              </v-toolbar>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="clearallfield(),VegeNext(),checkingProudctType()"
                    v-on:change="clearallfield(),checkingProudctType()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="LocationNext()"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!-- Type Price -->
                <v-flex xs2 v-if="setting_price == true">
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>
                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.01)"
                    type="number"
                    @keydown.tab.prevent="tabNext()"
                    @focus="$event.target.select()"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs2>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    ref="qty"
                    @keydown.tab.prevent="tabNext()"
                    @focus="$event.target.select()"
                    type="number"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>
                <!--  Select Basket  -->
                <v-flex xs1 v-if="product_type_need_basket === true">
                  <v-autocomplete
                    v-model="basket_need"
                    :items="basket_needList"
                    item-text="text"
                    item-value="value"
                    v-on:keyup.enter="BasketNext()"
                    label="Basket"
                    ref="basket"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs1>
                  <v-btn color="primary" @click="additemToPO(),tabNext()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>

                <v-layout>
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn  dark @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="stock"
                    :search="search"
                    disable-initial-sort
                    class="elevation-1"
                    :rows-per-page-items="[100, 150, 200, 250]"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.weight }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td
                          class="text-xs-right"
                          :style="{color: (props.item.total_weight.includes('deducted') ? 'green'  : '#000000' ) }"
                        >{{ props.item.total_weight }}</td>

                        <td class="text-xs-right">
                          <v-btn
                            @click="getBalanceRecord(props.item.balance_detail,props.item.product_id,props.item.vege_stocked_date)"
                            :color="(props.item.balance_detail.includes('over') ? 'warning'  : 'primary' )"
                          >{{props.item.balance_detail}}</v-btn>
                        </td>

                        <td class="text-xs">
                          <v-text-field
                            v-model="props.item.price"
                            label="price"
                            type="number"
                            @focus="$event.target.select()"
                           
                          ></v-text-field>
                            <!-- v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"  :placeholder="props.item.price"-->
                        </td>
                        <td class="text-xs-right">
                          <v-btn
                            color="red"
                            v-if="props.item.deduction_id === null"
                            @click="set_deduction(props.item.id,props.item.total_real_weight)"
                            dark
                          >Make Deduct</v-btn>
                          <v-btn
                            color="green"
                            v-else-if="props.item.deduction_id >0"
                            @click="set_deduction(props.item.id,props.item.total_real_weight)"
                            dark
                          >Edit Deduct</v-btn>
                        </td>
                        <td class="text-xs-right">{{ props.item.basket }}</td>
                        <td class="text-xs-right">RM{{ props.item.amount }}</td>

                        <td class="justify-end layout px-5">
                          <v-icon medium color="primary" @click="open_split_dialog(props.item.quantity,props.item.id)" >build</v-icon>
                          <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                          <v-icon
                            medium
                            color="error"
                            @click="deleteItem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                                <v-layout>
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn dark  @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="stock"
            :search="search"
            disable-initial-sort
            class="elevation-1"
            :rows-per-page-items="[20, 30, 50, 100]"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <v-avatar size="38">
                    <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                  </v-avatar>
                </td>
                <td class="text-xs-right">{{ props.item.product_name }}</td>
                <td class="text-xs-right">{{ props.item.grade }}</td>
                <td class="text-xs-right">{{ props.item.location }}</td>
                <td class="text-xs-right">{{ props.item.weight }}</td>
                <td class="text-xs-right">{{ props.item.quantity }}</td>
                <td
                  class="text-xs-right"
                  :style="{color: (props.item.total_weight.includes('deducted') ? 'green'  : '#000000' ) }"
                >{{ props.item.total_weight }}</td>

                <td class="text-xs-right">
                  <v-btn
                    @click="getBalanceRecord(props.item.balance_detail,props.item.product_id,props.item.vege_stocked_date)"
                    :color="(props.item.balance_detail.includes('over') ? 'warning'  : 'primary' )"
                  >{{props.item.balance_detail}}</v-btn>
                </td>

                <td class="text-xs-right">
                  <v-text-field
                    v-model="props.item.price"
                    label="price"
                    v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"
                    type="number"
                    @focus="$event.target.select()"
                    :placeholder="props.item.price"
                  ></v-text-field>
                </td>
                <td class="text-xs-right">
                  <v-btn
                    color="red"
                    v-if="props.item.deduction_id === null"
                    @click="set_deduction(props.item.id,props.item.total_real_weight)"
                    dark
                  >Make Deduction</v-btn>
                  <v-btn
                    color="green"
                    v-else-if="props.item.deduction_id >0"
                    @click="set_deduction(props.item.id,props.item.total_real_weight)"
                    dark
                  >Edit Deduction</v-btn>
                </td>
                <td class="justify-end layout px-5">
                  <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                  <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>-->
    </v-container>

    <v-dialog v-model="dialog_balance_record">
      <v-card>
        <v-card-title>
          <span class="headline">Record</span>
        </v-card-title>

        <v-card-text>
          <balance_record ref="balance_record"></balance_record>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="getPOStock(po_id,po_date,farmer_id)"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_deduction" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Deduction</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            label="Deduction KG"
            v-model="deduction_value"
            placeholder="kg"
            v-on:change="deduction_value = Math.max(Math.min(deduction_value, max_deduction_weight), 0)"
            outline
          ></v-text-field>

          <!-- <v-text-field
            label="Deduction Quantity"
            v-model="deduction_quantity"
            v-on:change="deduction_quantity = Math.max(Math.min(Math.round(deduction_quantity), max_deduction_quantity), 0)"
            placeholder="qty"
            outline
          ></v-text-field>-->
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn flat color="primary" @click="update_deduction()">Save</v-btn>
          <v-btn flat color="primary" @click="dialog_deduction = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_change_detail" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Change</span>
        </v-card-title>
        <v-card-text>
          <v-flex xs11>
            <v-menu
              lazy
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                label="Date"
                v-model="po_created_date"
                persistent-hint
                outline
                readonly
              ></v-text-field>

              <v-date-picker v-model="po_created_date" no-title actions></v-date-picker>
            </v-menu>
          </v-flex>
          <!-- customer selection  -->
          <v-flex xs11>
            <v-autocomplete
              v-model="farmer_id"
              :items="farmerList"
              item-text="name"
              item-value="id"
              label="Farmer"
              persistent-hint
              small-chips
              outline
            ></v-autocomplete>
          </v-flex>

          <!-- delivery driver selection  -->
          <v-flex xs11>
            <v-autocomplete
              v-model="driver_id"
              :items="driverList"
              item-text="username"
              item-value="id"
              label="Driver (may leave blank)"
              persistent-hint
              small-chips
              outline
            ></v-autocomplete>
          </v-flex>
          <v-flex xs11>
            <v-text-field outline type="number" label="sewa price" v-model="sewa_price"></v-text-field>
          </v-flex>
           <v-flex xs11>
            <v-text-field outline label="refer number" v-model="ref_no"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="updatePoDetail()">Save</v-btn>
          <v-btn flat @click="dialog_change_detail=false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="split_dialog" max-width="400px">
        <v-card>
          <v-card-title>Split (cannot more then{{max_split_quantity-1}})</v-card-title>
          <v-card-text>
             <v-text-field
            label="Split quantity"
            v-model="split_quantity"
            v-on:change="split_quantity = Math.max(Math.min(split_quantity, max_split_quantity-1), 1)"
            outline
          ></v-text-field>
          </v-card-text>
            <v-card-actions>
          <v-btn flat @click="split_qty()">Save</v-btn>
          <v-btn flat @click="split_dialog=false">close</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/po_edit_dialog";
import balance_record from "@/components/large_component/balance_price_detail";

import moment from "moment";
import { debounce } from "lodash";

export default {
  components: {
    edit_dialog,
    balance_record
  },
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    errors: "",
    saving: false,
    baseUrl: baseUrl,
    dialog_edit: false,
    headers: [
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "right", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Location", align: "right", value: "location" },
      { text: "Weight", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "Total Kg/box", align: "right", value: "total_weight" },
      { text: "Balance PRICE", align: "right", value: "balance_detail" },
      { text: "Price", align: "right", value: "price" },

      { text: "Deduction", align: "right", value: "deduction_id" },
      { text: "Basket?", align: "right", value: "basket" },

      { text: "Amount", align: "right", value: "amount" },

      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    response: "",
    type_need_weight: false,
    //logic control
    product_type_need_weight: true,
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    limitDay: "",

    date: moment().format("YYYY-MM-DD"),
    po_date: "",
    po_id: "",
    product: "",
    weight: "",
    quantity: "",
    price: "",

    grade: "unknown",
    location: "unknown",
    basket_control_type: "",
    basket_quantity: "",
    farmer_id: "",
    basket_added_before: false,
    product_type_need_basket:true,

    deduction_quantity: "",
    deduction_value: "",
    old_deduction_value: "",
    new_deduction_vale: "",
    deduction_created: false,
    stock_in_id: "",

    max_deduction_weight: "",

    dialog_balance_record: false,

    total_amount: "",

    farmer_name: "",
    farmer_id: "",
    driver_name: "",
    driver_id: "",
    po_created_date: "",
    sewa_price: "",
    sprice: "",
    dialog_change_detail: false,
    driverList: [],
    farmerList: [],

    productList: [],
    gradeList: [],
    locationList: [],
    // dialog snackbar date_box
    dialog_deduction: false,
    setting_dialog: false,
    date_box: false,
    vege_adding_loading_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response_detail: "",
    vege_adding_loading_value: "",
      basket_needList: [
        { text: "basket", value: true },
        { text: "no basket", value: false }
      ],
         basket: true,
      basket_need: "",
      split_dialog:false,
      max_split_quantity:"",
      split_quantity:"",
      split_stock_id:"",
      ref_no:""
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    },

    //  ref_no: function (val) {
    //   // this.ref_no = val + ' ' + this.lastName
    //     val.replace(",", ";");
    // },
  },
  mounted() {
    this.intervalFetch();
  },

  created() {
    this.getFarmer();
    this.getDriver();
    this.getProduct();
    this.getGrade();
    this.getLocation();
  },

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDriver() {
      const params = new URLSearchParams();
      params.append("get_driver", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_driver.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.driverList = response.data.data;
          } else if (response.data.error == true) {
            console.log(" Driver List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getPOStock(po_id, po_date, farmer_id) {
      console.log('gegegege');
      this.stock =[];
      this.total_amount = 0;
      this.dialog_edit = false;
      this.po_id = po_id;
      this.po_date = po_date;
      this.farmer_id = farmer_id;
      this.getPODetail();
      this.get_basket();

      const params = new URLSearchParams();

      params.append("getPOStock", "getPOStock");
      params.append("po_id", po_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.stock = response.data.data;
            for (var i = 0; i < this.stock.length; i++) {
              var row_amount =parseFloat(
                this.stock[i].total_real_weight * this.stock[i].price).toFixed(2);

              this.$set(
                this.stock[i],
                "amount",
                parseFloat(row_amount).toFixed(2)
              );
              this.total_amount += parseFloat(row_amount);

              if(parseFloat(this.stock[i].basket_item_quantity)>0){
                this.$set(
                this.stock[i],
                "basket",
                "basket"
              );
              }else{
                this.$set(
                this.stock[i],
                "basket",
                "no basket"
              );
              }
            }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getPODetail() {
      console.log('gege');
      const params = new URLSearchParams();

      params.append("getPODetail", "getPODetail");
      params.append("po_id", this.po_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var po_detail = response.data.data;
            this.farmer_name = po_detail[0].farmer_name;
            this.driver_name = po_detail[0].driver_name;
            this.po_created_date = po_detail[0].created_at;
            this.driver_id = po_detail[0].driver_id;
            this.farmer_id = po_detail[0].farmer_id;
            this.sprice = po_detail[0].sewa_price;
            this.sewa_price = po_detail[0].sewa_price;
            this.ref_no = po_detail[0].ref_no;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    updatePoDetail() {
      const params = new URLSearchParams();
      // this.ref_no=this.ref_no.replace(",", "/");
      // this.ref_no=this.ref_no.replace(";", "/");
      this.ref_no=this.ref_no.split(',').join('/');
      this.ref_no=this.ref_no.split(';').join('/');


      
      params.append("updatePoDetail", "updatePoDetail");
      params.append("po_id", this.po_id);
      params.append("farmer_id", this.farmer_id);
      params.append("driver_id", this.driver_id);
      params.append("date", this.po_created_date);
      params.append("sewa_price", this.sewa_price);
      params.append("ref_no", this.ref_no);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getPOStock(this.po_id, this.po_created_date, this.farmer_id);
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.dialog_change_detail = false;
            this.$emit("update", "someValue");
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deletePOStock", "deletepOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    additemToPO() {
      //checking whether data filled
      if (this.weight != null && this.quantity != null) {
        console.log;
        if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }
        const params = new URLSearchParams();
        params.append("additemToPO", "additemToPO");
        params.append("date", this.po_date);
        params.append("po_id", this.po_id);
        params.append("product_id", this.product.id);
        params.append("type", this.product.type);
        params.append("weight", this.weight);
        params.append("grade", this.grade);
        params.append("location", this.location);
        params.append("quantity", this.quantity);
        params.append("price", this.price);
        params.append("farmer_id", this.farmer_id);
        // params.append("basket", this.basket_need);
        params.append("basket", (this.basket_need==true?'1':'0'));


        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              //set response to selected data

              this.getPOStock(this.po_id, this.po_date, this.farmer_id);
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
          });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    get_basket() {
      const params = new URLSearchParams();
      params.append("readPOBasket", "readPOBasket");
      params.append("po_id", this.po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var quantity = [];
            quantity = response.data.data;

            for (var g = 0; g < quantity.length; g++) {
              var basket_q = quantity[g].quantity;
              var type = quantity[g].type;

              this.basket_quantity = basket_q;
              if (type == "11") {
                this.basket_control_type = "farmer_return";
              } else {
                this.basket_control_type = "driver_send";
              }
            }

            this.basket_added_before = true;
          } else if (response.data.error == true) {
            this.basket_control_type = "driver_send";

            this.basket_quantity = "";
            this.basket_added_before == false;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    update_basket() {
      this.saving = true;
      const params = new URLSearchParams();
      console.log(this.basket_added_before);
      if (this.basket_added_before) {
        params.append("update", "update");
      } else {
        params.append("create", "create");
      }
      params.append("po_id", this.po_id);
      params.append("farmer_id", this.farmer_id);
      params.append("quantity", this.basket_quantity);
      params.append("date", this.po_date);
      params.append("status", this.basket_control_type);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params,
        header: {
          "content-type": "application/x-www-form-urlencoded"
        }
      })
        .then(response => {
          console.log(response.data);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = "sucessful";
            this.basket_added_before = true;
            this.saving = false;
            this.$emit("update", "someValue");

          } else {
            this.snackbar_response = true;
            this.response_detail = "error";
            this.saving = false;
            this.$emit("update", "someValue");

          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
          this.saving = false;
        });
    },
    checkingProudctType() {
      // if (this.product.type == "box") {
      //   this.product_type_need_weight = false;
      //   this.weight = "1";
      // } else {
      //   this.product_type_need_weight = true;
      //   this.weight = "";
      // }
      if (this.product.type.trim() == "box" || this.product.type.trim() == "bag" || this.product.type.trim() == "pcs"  || this.product.type.trim() == "pkt") {
        this.product_type_need_basket = false;
        this.basket_need = false;
        this.product_type_need_weight = false;
        this.basket = false;
        this.weight = "1";
      } else if (this.product.type.trim() == "non-basket") {
        this.product_type_need_basket = false;
        this.product_type_need_weight = true;
        this.basket_need = false;
        this.basket = false;
        this.weight = "";
      } else {
        this.product_type_need_basket = true;
        this.product_type_need_weight = true;
        this.basket_need = true;
        this.basket = true;
        this.weight = "";
      }
    },
    VegeNext() {
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        // this.grade = "unknown";
        this.$refs.grade.activateMenu();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
        // this.location="unknown";
      } else if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    GradeNext() {
      // if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      // } else if (this.product.type == "box") {
      //   this.$refs.qty.focus();
      // } else {
      //   this.$refs.weight.focus();
      // }
      if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
        // this.location = "unknown";
      } else if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    LocationNext() {
      // if (this.product.type == "box") {
      //   this.$refs.qty.focus();
      // } else {
      //   this.$refs.weight.focus();
      // }
      if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      this.additemToPO();
      if (this.product_type_need_weight == true) {
        this.weight = "";
        this.quantity = "1";
        this.$refs.weight.focus();
      } else {
        this.quantity = "";
        this.$refs.qty.focus();
      }
    },
    PriceNext() {
      if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    clearallfield() {
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
      this.location = "";
    },
    DebounceUpdatePrice: _.debounce(function(id, price) {
      this.updatePrice(id, price);
    }, 300),

    updatePrice(id, price) {
      const params = new URLSearchParams();
      params.append("updatePrice", "updatePrice");
      params.append("id", id);
      params.append("price", price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    bulkupdatePrice() {
      const params = new URLSearchParams();
      params.append("bulkupdatePrice", "bulkupdatePrice");
      // params.append("id", id);
      params.append("stock", JSON.stringify(this.stock));

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          } else if (response.data.error == true) {
            
            this.snackbar_response = true;
            this.response_detail = "Failed. Try reupdate";
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    editItem(id) {
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id,this.farmer_id);
    },
    set_deduction(stock_in_id, total_real_weight) {
      this.max_deduction_weight = total_real_weight;
      // this.max_deduction_quantity = quantity;

      console.log(this.max_deduction_weight);

      this.dialog_deduction = true;
      this.stock_in_id = stock_in_id;

      const params = new URLSearchParams();
      params.append("read", "updatePrice");
      params.append("stock_in_id", stock_in_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/deduction.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var array = response.data.deduction;
            for (var g = 0; g < array.length; g++) {
              var weight = array[g].weight;
              var quantity = array[g].quantity;

              this.old_deduction_value = weight;
              this.deduction_value = weight;
              // this.deduction_quantity = quantity;
            }
            response.data.deduction = this.deduction_value;
            this.deduction_created = true;
          } else if (response.data.error == true) {
            this.old_deduction_value = "";
            this.deduction_value = "0";
            this.deduction_quantity = "1";

            this.deduction_created = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    update_deduction() {
      const params = new URLSearchParams();
      if (this.deduction_created == false) {
        params.append("create", "updatePrice");
        params.append("deduce_weight", this.deduction_value);
        params.append("quantity", "1");
        params.append("stock_in_id", this.stock_in_id);
      } else {
        params.append("update", "updatePrice");
        params.append("new_deduce_weight", this.deduction_value);
        params.append("quantity", "1");

        params.append("stock_in_id", this.stock_in_id);
      }

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/deduction.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.set_deduction(this.stock_in_id);
            this.snackbar_response = true;
            this.response_detail = "successful";
            this.dialog_deduction = false;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          } else if (response.data.error == true) {
            this.set_deduction(this.stock_in_id);
            this.snackbar_response = true;
            this.response_detail = "failed";
            this.dialog_deduction = false;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getBalanceRecord(balance_detail, product_id, vege_stocked_date) {
      console.log(product_id);
      console.log(vege_stocked_date);
      this.dialog_balance_record = true;
      this.$refs.balance_record.getrecord(
        balance_detail,
        vege_stocked_date,
        product_id
      );
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    },
    tabNext() {
      this.$refs.product.focus();
      this.$refs.product.activateMenu();
      this.product = "";

      this.grade = "";
      this.location = "";
      this.basket_need = "";
      this.price = "";
      this.weight = "";
      this.quantity = "";
    },
    open_split_dialog(max_quantity,stock_id){
      this.split_stock_id=stock_id;
      this.split_dialog=true;
      this.max_split_quantity=max_quantity;

    },
    split_qty() {
      const params = new URLSearchParams();
      params.append("po_split", "po_split");
      params.append("stock_id",  this.split_stock_id);
      params.append("split_quantity", this.split_quantity);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_split.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.data;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
                this.split_dialog=false;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.data;
            this.getPOStock(this.po_id, this.po_date, this.farmer_id);
                this.split_dialog=false;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
  }
};
</script>

